export const sendEmailToCustomerQuerySavings = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueComparing: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;

export const sendInactivityEmailToCustomerQuerySavings = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueComparingInactivity: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;
